export default __webpack_public_path__ + "static/media/et-ti.bd0d57c5.svg";